import { useEffect } from "react";
import { useSelector } from "react-redux";

import { getLocation } from "../../../ducks/location/selectors";
import { usePresentationMode } from "../../../hooks/layout/usePresentationMode";
import { RoutePanelName } from "../../../appConfig/types";

export const useDashboardPresentation = () => {
  const { payload } = useSelector(getLocation);
  const { isPresentationMode, togglePresentationMode } = usePresentationMode();

  useEffect(() => {
    if (!isPresentationMode && payload.panel === RoutePanelName.Presentation) {
      togglePresentationMode();
    }
  }, [payload.panel]);
};
